// @flow
import { memo } from 'react'
import cx from 'classnames'

import css from './Copyright.sass'

const currentYear = new Date().getFullYear()

type Props = {
  className?: string,
}

const CopyLink = () => (
  <a href='https://netology-group.ru' target='_blank' rel='noopener noreferrer'>
    Нетология-групп
  </a>
)

// eslint-disable-next-line prefer-arrow-callback
export const Copyright = memo<Props>(function Copyright({ className }: Props) {
  return (
    <div className={cx(css.root, className)}>
      © <CopyLink />, 2009–{currentYear}
    </div>
  )
})
